module.exports = __webpack_public_path__ + "img/panelView_baoSteel_2_2.179a7a30.png";